import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    current: {},
    currentLoading: false,
    listForCompetition: [],
    listForCompetitionLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },
    setCurrent(state, payload) {
      state.current = payload;
    },
    setCurrentLoading(state, payload) {
      state.currentLoading = payload;
    },
    setListForCompetition(state, payload) {
      state.listForCompetition = payload;
    },
    setListForCompetitionLoading(state, payload) {
      state.listForCompetitionLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("disciplines");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadByID({ commit }, id) {
      commit("setCurrentLoading", true);
      let response = await api.get("disciplines/byID", { params: { id: id } });
      commit("setCurrent", response.data[0]);
      commit("setCurrentLoading", false);
    },
    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("disciplines", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(() => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`disciplines`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(() => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async setParentDiscipline({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`disciplines/setParent`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(() => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    current(state) {
      return state.current;
    },
    currentLoading(state) {
      return state.currentLoading;
    },
    listForCompetition(state) {
      return state.listForCompetition;
    },
    listForCompetitionLoading(state) {
      return state.listForCompetitionLoading;
    },
    teamOnlyList(state) {
      return state.list.filter(discipline => discipline.isTeamDiscipline);
    },
    byID: state => id => {
      return state.list.find(discipline => discipline.id === id);
    }
  }
};
